export const formatUrl = (name: string) => {
  return name.split(" ").join("_");
};

export const revertFormatUrl = (name: string) => {
  return name.split("_").join(" ");
};
